
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipNoCommandG as ObiOwnShipNoCommandGElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-no-command-g.js';
 
 
 

 
 export const ObiOwnShipNoCommandG = createComponent({
   react: React,
   tagName: 'obi-own-ship-no-command-g',
   elementClass: ObiOwnShipNoCommandGElement,
   events: {
     
   }
  });
 
 